import { useContext } from 'react';
import { useStore as useZustandStore } from 'zustand';

import { NofomoStoreContext } from './context';
import { NofomoStore } from './zustand';

export const useNofomoStore = <T>(selector: (store: NofomoStore) => T): T => {
  const nofomoStoreContext = useContext(NofomoStoreContext);

  if (nofomoStoreContext === null) {
    throw new Error(`useStore must be use within NofomoStoreProvider`);
  }

  return useZustandStore(nofomoStoreContext, selector);
};
